import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import FileUpload from '@mui/icons-material/FileUpload'
import { Box, FormControl, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import ComboBox from 'Components/ComboBox'
import { React, useEffect, useState } from 'react'
import { find, isEmpty } from 'lodash'
import { useForm } from 'react-hook-form'
import CustomButton from 'Components/CustomButton/CustomButton'
import { Input } from 'Components/Input'
import { makeGetRequest } from 'utils/api'
import { currentDate } from 'utils/helpers'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function CreateContact({ setContactModelOpen, fetchContacts }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const Titres = [
    { id: 1, label: 'Mme' },
    { id: 2, label: 'Mr' },
    { id: 3, label: 'Mlle' },
    { id: 4, label: 'Dr' },
    { id: 5, label: 'ST' },
  ]

  const [open, setOpen] = useState(true)
  const [openGroup, setOpenGroup] = useState(false)
  const [categories, setCategories] = useState([])
  const [Souscategories, setSousCategories] = useState([])
  const [selectedSousCategories, setSelectedSousCategories] = useState([])
  const [sousCategory, setSousCategory] = useState('')
  const [Groupes, setGroupes] = useState([])
  const [getPays, setPays] = useState([])
  const [file, setFile] = useState(null)
  const [getInformation, setInformation] = useState(false)
  const [getSocialMedia, setSocialMedia] = useState(false)
  const [getAddress, setAddress] = useState(false)

  useEffect(() => {
    if (!isEmpty(Souscategories)) {
      const selectedCat = find(Souscategories, ['category', sousCategory])
      setSelectedSousCategories([selectedCat])
    }
  }, [sousCategory])
  useEffect(() => {
    fetchCategories()
    fetchGroupes()
  }, [])

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      Date: currentDate(),
    },
  })

  const fetchPays = async () => {
    const url = '/api/Social/get-countries/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterPays = []
      data.forEach((v) => {
        filterPays.push({ label: `${v.CountryCode}`, id: v.id })
      })
      setPays([...filterPays])
    }
  }
  const fetchCategories = async () => {
    const url = '/api/Social/get-categories/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterCategories = []
      data.Categorie.forEach((v) => {
        filterCategories.push({ label: `${v.id}-${v.Categorie}`, id: v.id })
      })
      const filterSousCategories = []
      data.SousCategorie.forEach((v) => {
        filterSousCategories.push({
          label: `${v.id}-${v.SousCategorie}`,
          id: v.id,
          category: v.Categorie,
        })
      })
      setSousCategories([...new Set(filterSousCategories)])
      setCategories([...new Set(filterCategories)])
    }
  }
  const fetchGroupes = async () => {
    const url = '/api/Social/get-groups/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterGroupes = []
      data.forEach((v) => {
        filterGroupes.push(v.Name)
      })
      setGroupes(filterGroupes)
    }
  }

  const handleClickOpen = () => {
    setOpen(true)
    fetchCategories()
    fetchGroupes()
  }

  const handleClose = () => {
    setOpen(false)
    setContactModelOpen(false)
    reset()
  }

  const onSubmit = (data) => {
    let url = '/api/Social/create-contact/'

    let formData = new FormData()

    if (getValues('Titre') !== null) {
      formData.append('Titre', getValues('Titre')?.id)
    }
    if (getValues('Nom') !== null) {
      formData.append('Nom', getValues('Nom'))
    }
    if (getValues('Prenom') !== null) {
      formData.append('Prenom', getValues('Prenom'))
    }
    if (getValues('Anniversaire') !== null) {
      formData.append('Anniversaire', getValues('Anniversaire'))
    }
    if (getValues('Portable') !== null) {
      formData.append('Portable', getValues('Portable'))
    }
    if (getValues('Email') !== null) {
      formData.append('Email', getValues('Email'))
    }
    if (getValues('Categorie') !== null) {
      formData.append('Categorie', getValues('Categorie')?.id)
    }
    if (getValues('SousCategorie') !== null) {
      formData.append('SousCategorie', getValues('SousCategorie')?.label)
    }
    if (getValues('Job') !== null) {
      formData.append('Job', getValues('Job'))
    }
    if (getValues('Société') !== null) {
      formData.append('Société', getValues('Société'))
    }
    if (getValues('Téléphone_pro') !== null) {
      formData.append('Téléphone pro', getValues('Téléphone_pro'))
    }
    if (getValues('Email_pro') !== null) {
      formData.append('Email pro', getValues('Email_pro'))
    }
    if (getValues('Instagram') !== null) {
      formData.append('Instagram', getValues('Instagram'))
    }
    if (getValues('Facebook') !== null) {
      formData.append('Facebook', getValues('Facebook'))
    }
    if (getValues('Linkedin') !== null) {
      formData.append('Linkedin', getValues('Linkedin'))
    }
    if (getValues('WebPage') !== null) {
      formData.append('WebPage', getValues('WebPage'))
    }
    if (getValues('Pays') !== null) {
      formData.append('Pays', getValues('Pays')?.id)
    }
    if (getValues('Ville') !== null) {
      formData.append('Ville', getValues('Ville'))
    }
    formData.append('Groupes', getValues('Groupes'))

    formData.append('image', file)

    let response = makePostRequest(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
      {},
      true,
    )
      .then((res) => {
        if (res.status === 200) {
          fetchContacts()
          // return
          handleClose()
        }
      })
      .catch((err) => {
        console.log(err.response.data)
      })
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>{t('mesToDo.create')}</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle sx={{ color: 'black !important' }}>{t('mesToDo.contactsCreateTitle')}</DialogTitle>
        <Box>
          {/* <form onSubmit={handleSubmit(onSubmit)}> */}
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => setValue('Titre', j)}
              label="Titre"
              data={Titres}
              name="Titre"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                size: 'small',
                type: 'text',
                required: true,
              }}
              name="Nom"
              label="Nom"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                required: true,
              }}
              name="Prenom"
              label={t('mesToDo.fieldFirstName')}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'Date',
              }}
              rules={{ required: true }}
              name="Anniversaire"
              sx={{ width: '98%' }}
              InputLabelProps={{ shrink: true }}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
              }}
              name="Portable"
              label="Portable"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
              }}
              name="Email"
              label="Email"
            />

            <ComboBox
              handleAutoComplete={(e, j) => setValue('Categorie', j)}
              label="Categorie"
              data={categories}
              name="Categorie"
              onClose={(event) => {
                setSousCategory(event.target.innerHTML.split('-')[1])
              }}
            />
            <ComboBox
              handleAutoComplete={(e, j) => setValue('SousCategorie', j)}
              label="SousCategorie"
              data={selectedSousCategories}
              name="SousCategorie"
            />

            <Stack mt={2} justifyContent="center" width={'100%'}>
              <Button variant="outlined" component="label">
                <FileUpload /> {t('mesToDo.uploadPhoto')}
                <input type="file" hidden onChange={(e) => setFile(e.target.files[0])} />
              </Button>
            </Stack>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <>
                <CustomButton sx={{ color: '#1d78d2' }} onClick={() => setOpenGroup(true)}>
                  {t('mesToDo.groupAssignment')} <ArrowForwardIcon />
                </CustomButton>
                <Dialog
                  fullWidth
                  maxWidth="xs"
                  open={openGroup}
                  onClose={() => setOpenGroup(false)}
                >
                  <DialogTitle sx={{ color: 'black !important' }}>{t('mesToDo.contactsGroup')}</DialogTitle>
                  <Box>
                    <DialogContent>
                      <FormControl>
                        <RadioGroup
                          onChange={(e) => {
                            setValue('Groupes', e.target.value)
                          }}
                          aria-labelledby="Groupes"
                          defaultValue="female"
                          name="Groupes"
                        >
                          {Groupes.map((v) => {
                            return (
                              <FormControlLabel
                                key={v.index}
                                value={v}
                                control={<Radio />}
                                label={v}
                              />
                            )
                          })}
                        </RadioGroup>
                      </FormControl>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setOpenGroup(false)}>{t('mesToDo.validate')}</Button>
                      <Button onClick={() => setOpenGroup(false)}>{t('mesToDo.cancel')}</Button>
                    </DialogActions>
                  </Box>
                </Dialog>
              </>
              <>
                <CustomButton sx={{ color: '#1d78d2' }} onClick={() => setInformation(true)}>
                  {t('mesToDo.professionalInformation')} <ArrowForwardIcon />
                </CustomButton>
                <Dialog
                  fullWidth
                  maxWidth="xs"
                  open={getInformation}
                  onClose={() => setInformation(false)}
                >
                  <DialogTitle sx={{ color: 'black !important' }}>{t('mesToDo.contactsProInfo')}</DialogTitle>
                  <Box>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                        }}
                        name="Job"
                        label="Job"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                        }}
                        name="Société"
                        label={t('mesToDo.fieldCompany')}
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          size: 'small',
                          type: 'text',
                        }}
                        name="Téléphone_pro"
                        label={t('mesToDo.fieldPhonePro')}
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                        }}
                        name="Email_pro"
                        label="Email pro"
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setInformation(false)}>{t('mesToDo.validate')}</Button>
                      <Button onClick={() => setInformation(false)}>{t('mesToDo.cancel')}</Button>
                    </DialogActions>
                  </Box>
                </Dialog>
              </>
              <>
                <CustomButton sx={{ color: '#1d78d2' }} onClick={() => setSocialMedia(true)}>
                  {t('mesToDo.contactsSocial')} <ArrowForwardIcon />
                </CustomButton>
                <Dialog
                  fullWidth
                  maxWidth="xs"
                  open={getSocialMedia}
                  onClose={() => setSocialMedia(false)}
                >
                  <DialogTitle sx={{ color: 'black !important' }}>{t('mesToDo.contactsNetworks')}</DialogTitle>
                  <Box>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                        }}
                        name="Instagram"
                        label="Instagram"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                        }}
                        name="Facebook"
                        label="Facebook"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          size: 'small',
                          type: 'text',
                        }}
                        name="Linkedin"
                        label="Linkedin"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                        }}
                        name="WebPage"
                        label="Web Page"
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setSocialMedia(false)}>{t('mesToDo.validate')}</Button>
                      <Button onClick={() => setSocialMedia(false)}>{t('mesToDo.cancel')}</Button>
                    </DialogActions>
                  </Box>
                </Dialog>
              </>
              <>
                <CustomButton
                  sx={{ color: '#1d78d2' }}
                  onClick={() => {
                    setAddress(true)
                    fetchPays()
                  }}
                >
                  {t('mesToDo.contactsAddress')} <ArrowForwardIcon />
                </CustomButton>
                <Dialog fullWidth maxWidth="xs" open={getAddress} onClose={() => setAddress(false)}>
                  <DialogTitle sx={{ color: 'black !important' }}>{t('mesToDo.contactsAddress')}</DialogTitle>
                  <Box>
                    <DialogContent>
                      <ComboBox
                        handleAutoComplete={(e, j) => setValue('Pays', j)}
                        label="Pays"
                        data={getPays}
                        name="Pays"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                        }}
                        name="Ville"
                        label="Ville"
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setAddress(false)}>{t('mesToDo.validate')}</Button>
                      <Button onClick={() => setAddress(false)}>{t('mesToDo.cancel')}</Button>
                    </DialogActions>
                  </Box>
                </Dialog>
              </>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={onSubmit}>{t('mesToDo.validate')}</Button>
            <Button onClick={handleClose}>{t('mesToDo.cancel')}</Button>
          </DialogActions>
        </Box>
      </Dialog>
    </>
  )
}
